import {useContext, useState} from 'react';
import {BulletinHoursListIdsRequest} from '../../../infrastructure/remote/sacmi/dto/request/BulletinHoursListIdsRequest';
import {DependencyInjection, DependencyInjectionContext} from '../../../view/context/DependencyInjectionContext';
import ExportSummaryExcelUseCase from '../domain/useCase/ExportSummaryExcelUseCase';

interface CustomButtonListSummaryResponse {
    handleExportExcel: (filters: BulletinHoursListIdsRequest) => void;
    loading: boolean;
    error: string;
    clearError: () => void;
}

export const useCustomButtonListSummaryController = (): CustomButtonListSummaryResponse => {
    const dependencyInjectionContext =
        useContext(DependencyInjectionContext) || ({} as DependencyInjection);

    const [loading, setLoading] = useState<boolean>(false);
    const [error, setError] = useState<string>('');

    const handleExportExcel = async (filters: BulletinHoursListIdsRequest) => {
        if (loading) return;
        setLoading(true);
        setError('');
        const exportTask = ExportSummaryExcelUseCase({
            summaryRepository: dependencyInjectionContext.summaryRepository,
            filters,
        });
        await exportTask.then((task: any): void => {
            task
                .onSuccess((response: {data: {url: string}}) => {
                    const link = document.createElement('a');
                    link.href = response.data.url;
                    link.target = '_blank';
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                })
                .onFail((error: string) => {
                    setError(error || 'Error al exportar Excel');
                })
                .execute();
        }).finally(() => setLoading(false));
    };

    const clearError = () => setError('');

    return {
        handleExportExcel,
        loading,
        error,
        clearError,
    }
}
